import React, { useState } from 'react';
import { Phone, Mail, Clock, MailCheck } from 'lucide-react';

const ContactUs = () => {
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState("");

  return (
    /* pt-24 (Desktop) aur pt-20 (Mobile) navbar overlap fix karne ke liye */
    /* id="contact" aur scroll-mt-24 taaki click karne par sahi jagah ruke */
    <section 
      id="contact" 
      className="pt-24 pb-12 md:pt-32 md:pb-24 px-4 bg-white max-w-7xl mx-auto scroll-mt-24"
    >
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 uppercase tracking-tighter">
          Ready to <span className="text-blue-600">Travel?</span>
        </h2>
        <div className="w-16 md:w-20 h-1.5 bg-blue-600 mx-auto mt-4 md:mt-6 rounded-none"></div>
      </div>

      {/* Main Container */}
      <div className="flex flex-col lg:flex-row bg-white rounded-none overflow-hidden shadow-2xl border border-gray-100 min-h-[600px]">
        
        {/* Left Side: Contact Info */}
        <div className="lg:w-1/3 bg-[#0a1128] p-8 md:p-12 text-white flex flex-col justify-start">
          <div className="text-left">
            <h3 className="text-2xl md:text-3xl font-black mb-6 uppercase tracking-tight">Contact Information</h3>
            <p className="text-gray-400 mb-10 md:mb-12 leading-relaxed text-sm font-medium italic">
              Have a specific requirement? Our dedicated corporate desk is available 24/7 to assist you.
            </p>
            
            <div className="space-y-8 md:space-y-10">
              <div className="flex items-start gap-4 md:gap-5">
                <div className="bg-blue-600/20 p-3 md:p-4 rounded-none border border-blue-500/30 text-blue-400 shrink-0">
                  <Phone size={20} className="md:w-6 md:h-6" />
                </div>
                <div className="text-left">
                  <p className="text-[10px] text-gray-400 uppercase tracking-[0.2em] font-black mb-1 md:mb-2">Call for booking</p>
                  <p className="text-base md:text-lg font-bold leading-relaxed whitespace-nowrap">+91 44 2822 4413<br />+91 44 2827 2279<br />+91 97 9111 1275</p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5">
                <div className="bg-blue-600/20 p-3 md:p-4 rounded-none border border-blue-500/30 text-blue-400 shrink-0">
                  <Mail size={20} className="md:w-6 md:h-6" />
                </div>
                <div className="text-left overflow-hidden">
                  <p className="text-[10px] text-gray-400 uppercase tracking-[0.2em] font-black mb-1 md:mb-2">Email Us</p>
                  <p className="text-base md:text-lg font-bold break-all md:break-normal">bookings@expresstravelcorp.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4 md:gap-5">
                <div className="bg-blue-600/20 p-3 md:p-4 rounded-none border border-blue-500/30 text-blue-400 shrink-0">
                  <Clock size={20} className="md:w-6 md:h-6" />
                </div>
                <div className="text-left">
                  <p className="text-[10px] text-gray-400 uppercase tracking-[0.2em] font-black mb-1 md:mb-2">Response Time</p>
                  <p className="text-base md:text-lg font-bold text-green-400 tracking-tight">Approximate 15 Minutes</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Form */}
        <div className="lg:w-2/3 p-6 md:p-12 bg-gray-50/50 flex items-center justify-center">
          {submitted ? (
            <div className="text-center py-10">
              <div className="w-16 h-16 md:w-20 md:h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <MailCheck size={32} className="md:w-10 md:h-10" />
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-gray-900 uppercase mb-2">Enquiry Sent</h3>
              <p className="text-gray-500 mb-8 italic text-sm">We'll get back to you within 15 minutes.</p>
              <button
                onClick={() => { setSubmitted(false); setName(""); }}
                className="bg-gray-900 text-white py-4 px-8 md:px-10 font-black uppercase tracking-widest text-xs rounded-none transition-colors hover:bg-blue-600"
              >
                Send Another
              </button>
            </div>
          ) : (
            <div className="w-full">
              <iframe title="Contact Form Submission" name="hidden_iframe_contact" style={{ display: "none" }}></iframe>
              <form
                action="https://formsubmit.co/enquiry@expresstravelcorp.com"
                method="POST"
                target="hidden_iframe_contact"
                onSubmit={() => {
                  setTimeout(() => setSubmitted(true), 1000);
                }}
                className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 w-full"
              >
                <input type="hidden" name="_subject" value={`New Enquiry - ${name}`} />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                <div className="space-y-2 text-left">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Full Name</label>
                  <input
                    required
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    onChange={(e) => setName(e.target.value)}
                    className="w-full p-4 md:p-5 rounded-none border border-gray-200 focus:border-blue-500 bg-white transition-all outline-none text-sm"
                  />
                </div>

                <div className="space-y-2 text-left">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Work Email</label>
                  <input
                    required
                    type="email"
                    name="email"
                    placeholder="name@company.com"
                    className="w-full p-4 md:p-5 rounded-none border border-gray-200 focus:border-blue-500 bg-white transition-all outline-none text-sm"
                  />
                </div>

                <div className="space-y-2 text-left">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Phone Number</label>
                  <input
                    required
                    type="tel"
                    name="phone"
                    placeholder="+91 00000 00000"
                    className="w-full p-4 md:p-5 rounded-none border border-gray-200 focus:border-blue-500 bg-white transition-all outline-none text-sm"
                  />
                </div>

                <div className="space-y-2 text-left">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Service Required</label>
                  <div className="relative">
                    <select
                      name="service"
                      required
                      className="w-full p-4 md:p-5 rounded-none border border-gray-200 bg-white cursor-pointer focus:border-blue-500 outline-none appearance-none pr-12 text-sm font-bold text-slate-700"
                      defaultValue=""
                    >
                      <option value="" disabled>Select a Service</option>
                      <option value="Corporate Fleet">Corporate Fleet</option>
                      <option value="Luxury Rental">Luxury Rental</option>
                      <option value="Airport Transfers">Airport Transfers</option>
                      <option value="Employee Transport">Employee Transport</option>
                      <option value="Events Logistics">Events Logistics</option>
                      <option value="Intercity Trips">Intercity Trips</option>
                      <option value="VIP Concierge">VIP Concierge</option>
                      <option value="Overseas">Overseas</option>
                    </select>
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400">
                      <svg width="10" height="6" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="square"/>
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="md:col-span-2 space-y-2 text-left">
                  <label className="text-[10px] font-black uppercase tracking-widest text-slate-500">Your Requirements</label>
                  <textarea
                    required
                    rows="4"
                    name="message"
                    placeholder="Tell us about your travel needs..."
                    className="w-full p-4 md:p-5 rounded-none border border-gray-200 focus:border-blue-500 bg-white transition-all outline-none resize-none text-sm"
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="md:col-span-2 bg-blue-600 hover:bg-slate-900 text-white font-black py-4 md:py-5 rounded-none transition-all uppercase tracking-[0.2em] text-xs shadow-xl active:scale-[0.98]"
                >
                  Send Enquiry
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactUs;